<template>
<v-container fluid>
  <v-card>
    <v-card-title>
      <div class="flex-grow-1">
        Responsables administrativos
      </div>   
      <div class="flex-grow-1">
        <v-row justify="end">
          <v-col 
            cols="12" 
            sm="5"
          >
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              hide-details
              outlined
              dense
            />
          </v-col>
        </v-row>
      </div>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :search="search"
        calculate-widths
        loading-text="Cargando... Por favor espere"
        locale="es-ES"
      >
        <template v-slot:item.habilitado="{ item }">
          <v-icon :color="item.habilitado ? 'green' : 'red'">
            {{ item.habilitado ? 'mdi-check' : 'mdi-close' }}
          </v-icon>
        </template>
        <template v-slot:item.esTitular="{ item }">
          <v-icon :color="item.esTitular ? 'green' : 'red'">
            {{ item.esTitular ? 'mdi-check' : 'mdi-close' }}
          </v-icon>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn
                  color="primary"
                  icon
                  @click="fnSetEditResponsable(item)"
                >
                  <v-icon>
                    mdi-account-edit
                  </v-icon>
                </v-btn>
              </div>
            </template>
              <span>Editar Responsable Administrativo</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn
                  color="error"
                  icon
                  @click="fnSetDeleteResponsable(item)"
                >
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </div>
            </template>
              <span>Eliminar Responsable Administrativo</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
  <v-dialog v-model="dialogEliminar" persistent max-width="290">
    <v-card>
      <v-card-title class="headline">¿Está seguro?</v-card-title>
      <v-card-text>Esta por eliminar al responsable: <b>{{ itemDelete.nombre }}</b>. ¿Desea continuar?</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="black darken-1" text @click="dialogEliminar = false">Cancelar</v-btn>
        <v-btn color="error" text @click="fnEliminar">Eliminar</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-snackbar
    key="snackbarDataTableServicioResponsables"
    v-model="snackbar"
    :bottom="true"
    :multi-line="true"
    :color="snackbarColor"
  >
    {{ snackbarTexto }}
    <v-btn dark text @click="snackbar = false;">
      Cerrar
    </v-btn>
  </v-snackbar> 
</v-container>
</template>

<script>
import { getResponsablesByIdServicio, deleteResponsableServicio } from "@/api";

export default {
  name: "DataTableServicioResponsables",
  components: {
    //DialogHistoricoEspacioLectura: () => import("../LecturaVelocidadRed/DialogHistoricoEspacioLectura"),
  },
  props: {
    objServicio: {
      type: Object,
      required: true
    },
    flagReload: {
      type: Number,
      default: 0
    },
    fnOnLoaded: {
      type: Function,
      default: () => {}
    },
    fnSetEditResponsable: {
      type: Function,
      default: () => {}
    },
  },
  data () {
    return {
      loading: true,
      snackbar: false,
      snackbarColor: '',
      snackbarTexto: '',
      headers: [
        { align: "center", text: "NUE", value: "nue" },
        { align: "left", text: "Nombre", value: "nombre" },
        { align: "left", text: "Correo", value: "correo" },
        { align: "center", text: "Titular", value: "esTitular" },
        { align: "center", text: "Habilitado", value: "habilitado" },
        { align: "center", text: "Acciones", value: "acciones" }
      ],
      items: [],
      itemsFilter: [],
      search: "",
      dialog: false,
      itemSelected: {},

      itemDelete: {},
      dialogEliminar:  false,
      loadingEliminar: false,
      //numEspacios: 0,
      //numEspaciosConectOp: 0
    };
  },
  computed: {},
  watch: {
    flagReload: {
      handler (newValue, oldValue) {
        this.obtenerResponsables();
			},
    },
  },
  mounted () {
    this.obtenerResponsables();
  },
  methods: {
    async obtenerResponsables () {
      var self = this;
      self.loading = true;
      self.items = [];
      self.itemsFilter = [];
      self.snackbarError = false;
      self.textoError = "";

      try {
        let response = await getResponsablesByIdServicio(self.objServicio.idCatServicio);

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              self.items = response.data.data;
              self.loading = false;
              //self.filtrarItems();
            }
          } else {
            self.snackbarTexto = "DataTableServicioResponsables: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loading = false;
          }
        } else {
          self.snackbarTexto = "DataTableServicioResponsables: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loading = false;
        }
      } catch (e) {
        self.loading = false;
        self.snackbarTexto = "DataTableServicioResponsables: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
    fnSetDeleteResponsable(item){
      this.itemDelete = item;
      this.dialogEliminar = true;    
    },
    async fnEliminar(){
      var self = this;


      self.loadingEliminar = true;
      self.snackbar = false;
      self.snackbarTexto = "";
      self.snackbarColor = "";
          
      try {
        let response = await deleteResponsableServicio(self.itemDelete);
        

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Borrado correcto") {
              self.snackbarTexto = "Responsable administrativo eliminado con éxito";
              self.snackbarColor = "success";
              self.snackbar = true;

              self.obtenerResponsables();
            }
          } else {
            self.snackbarTexto = "DataTableServicioResponsablesAdministrativos: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
          }
        } else {
          self.snackbarTexto = "DataTableServicioResponsablesAdministrativos: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
        }
        self.loadingEliminar = false;
        self.dialogEliminar = false;
        self.itemDelete = {};
      } catch (e) {
        self.loadingEliminar = false;
        self.dialogEliminar = false;
        self.itemDelete = {};

        self.snackbarTexto = "DataTableServicioResponsablesAdministrativos: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    }
  }
};
</script>
